export const formatAddress = (address, padding = 4) => {
	if (address && address.length > 0) {
		return `${address.substr(0, padding)}…${address.substr(-padding)}`
	} else {
		return address
	}
}
